import { createAsyncThunk } from '@reduxjs/toolkit'

import { callErrorMsg } from 'helpers/errorMsg'

import { getLocationListAPI } from 'features/Enterprise/Account/services'
import {
  fetchPicListApi,
  getProductCategoryApi,
  fetchRlDeleteReasonsApi,
  fetchRlTagsApi,
} from 'features/Enterprise/ReorderList/services/reorderListFilter'

import {
  sliceName,
  setLocationList,
  setPicList,
  setProductCategory,
  setDeleteReasons,
  setTagList,
} from './reorderListFilterSlice'

export const fetchRlLocations = createAsyncThunk(
  `${sliceName}/fetchRlLocations`,
  async ({ name, type }: { name: string; type: string }, { dispatch }) => {
    try {
      const { data } = await getLocationListAPI({
        pageSize: '20',
        type,
        name,
      })

      dispatch(setLocationList(data?.content))
    } catch (err) {
      callErrorMsg(err)
    }
  },
)

export const fetchPicList = createAsyncThunk(
  `${sliceName}/fetchPicList`,
  async ({ name }: { name: string }, { dispatch }) => {
    try {
      const { data } = await fetchPicListApi({ name })
      dispatch(setPicList(data?.content))
    } catch (err) {
      callErrorMsg(err)
    }
  },
)

export const fetchProductCategoryList = createAsyncThunk(
  `${sliceName}/fetchProductCategoryList`,
  async ({ name = '' }: { name: string }, { dispatch }) => {
    const { data } = await getProductCategoryApi(name)
    dispatch(setProductCategory(data?.content || []))
  },
)

export const fetchRlDeleteReasons = () => async (dispatch: StoreDispatchType) => {
  try {
    const { data } = await fetchRlDeleteReasonsApi()
    dispatch(setDeleteReasons(data.data))
  } catch (err) {
    callErrorMsg(err)
  }
}

export const fetchRlTags = () => async (dispatch: StoreDispatchType) => {
  try {
    const { data } = await fetchRlTagsApi()
    dispatch(setTagList(data.data))
  } catch (err) {
    callErrorMsg(err)
  }
}
